import { render, staticRenderFns } from "./topbarTabs.vue?vue&type=template&id=1251f5be&"
import script from "./topbarTabs.vue?vue&type=script&lang=js&"
export * from "./topbarTabs.vue?vue&type=script&lang=js&"
import style0 from "./topbarTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports